module.exports = __webpack_public_path__ + "../front/img/768_med_5_hylder.4928067d.svg";